import React, { useState } from 'react';
import transformArrayToObject from '~/utils/transformArrayToObject';

const LogsProv = React.createContext({
  data: {
    data: [],
    page: 0,
    totalCount: 0,
  },
  records: {},
  setData: () => null,
  modifyData: () => null,
  deleteRecord: () => null,
});

export function LogsProvider({ children }) {
  const [records, setRecords] = useState({});
  const [data, setData] = useState({
    data: [],
    page: 0,
    totalCount: 0,
  });

  function addRecords(newData) {
    setData({ ...data, ...newData });

    const newRecords = transformArrayToObject(newData.data);
    setRecords({ ...records, ...newRecords });

    return newData;
  }

  return (
    <LogsProv.Provider value={{ data, addRecords, records }}>
      {children}
    </LogsProv.Provider>
  );
}

export default LogsProv;
